import { type FunctionalComponent, h } from '@stencil/core'
import { AccountPanel, type AccountPanelProps } from './AccountPanel'

export const AccountPanelOuter: FunctionalComponent<AccountPanelProps> = ({
  accountsData,
  selectedAccount,
  onSelectAccount,
  onRefreshAccounts,
  isLoadingAccount,
  isLoadingAccounts,
  accountsError,
  favoritesOnly,
  favoritesAccountsData,
  onToggleFavorite,
  debugConfig
}) => (
  <div class="debug-toolbar-panel open">
    <div class="debug-toolbar-header">
      <h3>Account Settings</h3>
    </div>
    <div class="debug-toolbar-section">
      <AccountPanel
        accountsData={accountsData}
        selectedAccount={selectedAccount}
        onSelectAccount={onSelectAccount}
        onRefreshAccounts={onRefreshAccounts}
        isLoadingAccount={isLoadingAccount}
        isLoadingAccounts={isLoadingAccounts}
        accountsError={accountsError}
        favoritesOnly={favoritesOnly}
        favoritesAccountsData={favoritesAccountsData}
        onToggleFavorite={onToggleFavorite}
        debugConfig={debugConfig}
      />
    </div>
  </div>
)
